var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortArrows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.997,
    height: 12,
    viewBox: "0 0 11.997 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-176 -291)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "up-arrow",
    d: "M8.162,0,7.495.668l1.9,1.9H0v.918H9.391l-1.9,1.813.668.668,2.981-2.981Z",
    transform: "translate(176 302.143) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "down-arrow",
    d: "M8.162,0,7.495.668l1.9,1.9H0v.918H9.391l-1.9,1.813.668.668,2.981-2.981Z",
    transform: "translate(187.997 291.857) rotate(90)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortArrows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sort-arrows.644523b9c11613b64d5d774ef368513a.svg";